import moment from 'moment';

import type { Zone } from '@sine/sine-core-api-types';
import type { ISelectOption } from '@sine/sine-ui-components';

export enum InvitationDateFilterValue {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  NEXT_7_DAYS = 'next7days',
  ALL_ACTIVE = 'allActive',
  EXPIRED = 'expired',
}

export interface InvitationDateFilter {
  label: string;
  value: InvitationDateFilterValue;
  params: { minDate?: number; maxDate?: number };
}

export const getInvitationDateFilters = (): Array<InvitationDateFilter> => [
  {
    label: 'Today',
    value: InvitationDateFilterValue.TODAY,
    params: { minDate: moment().unix(), maxDate: moment().endOf('day').unix() },
  },
  {
    label: 'Tomorrow',
    value: InvitationDateFilterValue.TOMORROW,
    params: {
      minDate: moment().add(1, 'days').startOf('day').unix(),
      maxDate: moment().add(1, 'days').endOf('day').unix(),
    },
  },
  {
    label: 'Next 7 days',
    value: InvitationDateFilterValue.NEXT_7_DAYS,
    params: {
      minDate: moment().add(1, 'day').startOf('day').unix(),
      maxDate: moment().add(7, 'days').endOf('day').unix(),
    },
  },
  {
    label: 'All active',
    value: InvitationDateFilterValue.ALL_ACTIVE,
    params: {
      minDate: moment().unix(),
    },
  },
  { label: 'Expired', value: InvitationDateFilterValue.EXPIRED, params: { minDate: undefined, maxDate: undefined } },
];

export default function getDefaultZone(
  zoneOptions: Array<ISelectOption>,
  selectedZone: Zone | undefined,
  defaultZoneForHostGroup: Zone | undefined,
  defaultZoneForSite: Zone | undefined,
) {
  const isZoneSelected = selectedZone && zoneOptions.some((option) => option.value === selectedZone.id);

  if (isZoneSelected && !selectedZone.default) {
    // This case returns the selected zone if the invitation has a zone selected and isn't the default zone
    return selectedZone;
  }

  // This case returns the Host Group default zone if available or the site zone default in case is a new invitation
  return defaultZoneForHostGroup || defaultZoneForSite;
}
